import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import App from './App'
import './index.css'
import './i18n' // Initialize i18n
import { PostHogProvider } from 'posthog-js/react'
import { LanguageProvider } from './contexts/LanguageContext'
import { initializeRemoteConfig } from './lib/featureFlags'

// Initialize Sentry
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn && sentryDsn !== 'YOUR_SENTRY_DSN') {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE || 'production',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.1'), // 10% of transactions
    // Session Replay
    replaysSessionSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || '0.1'), // 10% of sessions
    replaysOnErrorSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_ERROR_SAMPLE_RATE || '1.0'), // 100% of sessions with errors

    // Privacy settings
    beforeSend(event) {
      // Filter out sensitive data if needed
      return event;
    },
  });
} else {
  console.log('Sentry disabled (DSN not configured).');
}

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const isPostHogEnabled = posthogKey && posthogKey !== 'YOUR_POSTHOG_KEY';

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://app.posthog.com',
}

// Initialize Firebase Remote Config
initializeRemoteConfig().catch((error) => {
  console.error('Failed to initialize Remote Config:', error);
});

const root = ReactDOM.createRoot(document.getElementById('root')!);

if (isPostHogEnabled) {
  root.render(
    <React.StrictMode>
      <PostHogProvider apiKey={posthogKey} options={options}>
        <LanguageProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LanguageProvider>
      </PostHogProvider>
    </React.StrictMode>
  );
} else {
  console.log("PostHog disabled (key not configured).");
  root.render(
    <React.StrictMode>
      <LanguageProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LanguageProvider>
    </React.StrictMode>
  );
}
